const form = document.getElementById("custom-recharge-form");
const quantityInput = document.getElementById("recharge-quantity");
const quantityElement = document.getElementById("custom-recharge-form-quantity");
const summaryElement = document.getElementById("custom-recharge-form-summary");
const priceElement = document.getElementById("custom-recharge-form-price");
const save_text = document.getElementById("custom-recharge-form-saving");
const start_txt = $.trim($("a.commencer.header__icon.button.button--primary").text());

let config = { childList: true };
let radioContainer = document.getElementById("custom-recharge-form-radios");
let checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

let quantity;

const linkedProductsSelect = document.getElementById('linked-product-select');

if(quantityInput){
    quantity = parseInt(quantityInput.value);

    let targetNode = document.getElementsByClassName("recharge-subscription-widget")[0].getElementsByTagName("DIV")[0];

    let observer = new MutationObserver(function (mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                let select = targetNode.querySelector('select[name="rc_selling_plan"]');
                if (select) {
                    let options = select.options;
                    radioContainer.innerHTML = "";
    
                    for (let i = 0; i < options.length; i++) { // Création des radio butons en fonction du select Recharge
                        let option = options[i];
    
                        let divWrapper = document.createElement("div");
                        divWrapper.className = "custom-recharge-form-radio"
    
                        let radio = document.createElement("input");
                        radio.type = "radio";
                        radio.name = "selling_plan";
                        radio.value = option.value;
                        radio.setAttribute("form", productFormId);
                        radio.id = "recharge-frequency-" + i;
                        if (i === options.length - 1)
                            radio.checked = true;
                        
                        let label = document.createElement("label");
                        label.innerHTML = option.text + ((i === options.length - 1)? ' (Standard)' : ' (Extra contrôle des odeurs)');
                        label.setAttribute("for", "recharge-frequency-" + i);
    
    
                        divWrapper.appendChild(radio);
                        divWrapper.appendChild(label);
                        radioContainer.appendChild(divWrapper);
                    }
    
                    observer.disconnect();
                }
            }
        }
    });

    observer.observe(targetNode, config);

} else if(linkedProductsSelect){
    quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
}

// Fonction pour mettre à jour les détails en fonction des inputs
function updateFormDetails() {
    var val = $("#linked-product-select option:selected" ).text();
    if(val.indexOf("Katzen") != -1){
        const frequencyInputs = document.querySelectorAll('div[class="custom-recharge-form-radio"]');
        let frequency = "";

        if(quantityInput){
            quantity = parseInt(quantityInput.value);
        } else if(linkedProductsSelect){
            quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
        }
        $("p#custom-recharge-form-quantity").text(quantity+" Pacha-Beutel");   
        
        frequencyInputs.forEach((input) => {
            radio = input.querySelector('input')
            label = input.querySelector('label')
            if (radio.checked)
                frequency = label.textContent.replace('Livraison', 'livrés');
        });

        if(frequency.indexOf("3") != -1){
            var new_frequency = 3;
        } else {
            var new_frequency = 4;
        }

        $("p#custom-recharge-form-summary").text(quantity+" Beutel Streu werden alle "+new_frequency+" Wochen geliefert");

    } else {    
        const frequencyInputs = document.querySelectorAll('div[class="custom-recharge-form-radio"]');
        let frequency = "";

        if(quantityInput){
            quantity = parseInt(quantityInput.value);
        } else if(linkedProductsSelect){
            quantity = parseInt(linkedProductsSelect.options[linkedProductsSelect.selectedIndex].dataset.nb);
        }

        frequencyInputs.forEach((input) => {
            radio = input.querySelector('input')
            label = input.querySelector('label')
            if (radio.checked)
                frequency = label.textContent.replace('Livraison', 'livrés');
        });

        if (quantity > 1) {
            save_text.style.display = "block";
            priceElement.innerHTML = `<span class="compare-price">28.00 CHF</span> 26.00 CHF unité`
        }
        else {
            save_text.style.display = "none";
            priceElement.innerHTML = `26.00 unité`
        }

        const quantityText = `${quantity} sac${quantity > 1 ? 's' : ''} Pacha`;
        const summaryText = `${quantity} sac${quantity > 1 ? 's' : ''} de litière ${frequency}`;

        quantityElement.textContent = quantityText;
        summaryElement.textContent = summaryText;
    }
}

form.addEventListener("change", updateFormDetails);

// Fonction pour mettre à jour le select Recharge en fonction du radio custom checked
function updateSelectFromRadio() {
    if(targetNode){
      let select = targetNode.querySelector('select[name="rc_selling_plan"]');
    }
    checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');

    if (checkedRadio) {
        select.value = checkedRadio.value;
        let changeEvent = new Event('change', {
            bubbles: true,
            cancelable: true
        });
        // Déclenche l'événement "change" sur le select pour changer l'url avec le selling_plan (comportement normal de Recharge)
        select.dispatchEvent(changeEvent);
    }
}

if(quantityInput){
  radioContainer.addEventListener("change", updateSelectFromRadio);
}

let checkoutButton = document.querySelector('[checkout-button]');

// if(checkoutButton) {
//     checkoutButton.addEventListener('click', goCheckout);
// }
// if (checkoutButton) {
//     checkoutButton.addEventListener('click', function () {
//         alert("Checkout button clicked!");
       
//     });
// }

$(document).on('click', '.pacha-v2-atc', function(e) {
  e.preventDefault();
 

    const nextCommerceData = [
        {"shopifyId": "44598917497040", "nextCommerceId": "5", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598917693648", "nextCommerceId": "7", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598917791952", "nextCommerceId": "9", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598917824720", "nextCommerceId": "11", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598917857488", "nextCommerceId": "13", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598917955792", "nextCommerceId": "15", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598917988560", "nextCommerceId": "17", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918021328", "nextCommerceId": "19", "IntervalCount": "12", "FrequencyTitle": "week"},
        {"shopifyId": "44598918054096", "nextCommerceId": "21", "IntervalCount": "12", "FrequencyTitle": "week"},
        {"shopifyId": "44598918086864", "nextCommerceId": "43", "IntervalCount": "12", "FrequencyTitle": "week"},
        {"shopifyId": "44598918119632", "nextCommerceId": "35", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918152400", "nextCommerceId": "23", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918185168", "nextCommerceId": "25", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918217936", "nextCommerceId": "37", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918250704", "nextCommerceId": "39", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918283472", "nextCommerceId": "57", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918316240", "nextCommerceId": "49", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918349008", "nextCommerceId": "45", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918381776", "nextCommerceId": "29", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918414544", "nextCommerceId": "51", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918447312", "nextCommerceId": "55", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918480080", "nextCommerceId": "69", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918545616", "nextCommerceId": "31", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44790981624016", "nextCommerceId": "169", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598918807760", "nextCommerceId": "139", "IntervalCount": "", "FrequencyTitle": "week"},
        {"shopifyId": "44598918840528", "nextCommerceId": "61", "IntervalCount": "12", "FrequencyTitle": "week"},
        {"shopifyId": "44598918873296", "nextCommerceId": "67", "IntervalCount": "12", "FrequencyTitle": "week"},
        {"shopifyId": "44598918906064", "nextCommerceId": "53", "IntervalCount": "12", "FrequencyTitle": "week"},

        {"shopifyId": "44900868817104", "nextCommerceId": "264", "IntervalCount": "4", "FrequencyTitle": "week"}, // 24 sacs  71
        {"shopifyId": "44900868489424", "nextCommerceId": "262", "IntervalCount": "4", "FrequencyTitle": "week"}, // 12 sacs  59
        {"shopifyId": "44900868456656", "nextCommerceId": "260", "IntervalCount": "4", "FrequencyTitle": "week"}, // 11 sacs  89
        {"shopifyId": "44900868227280", "nextCommerceId": "258", "IntervalCount": "4", "FrequencyTitle": "week"}, // 10 sacs  95
        {"shopifyId": "44900868194512", "nextCommerceId": "256", "IntervalCount": "4", "FrequencyTitle": "week"}, // 9 sacs  73
        {"shopifyId": "44900867866832", "nextCommerceId": "254", "IntervalCount": "4", "FrequencyTitle": "week"}, // 8 mois  65
        {"shopifyId": "44900867080400", "nextCommerceId": "252", "IntervalCount": "4", "FrequencyTitle": "week"}, // 7 mois  81
        {"shopifyId": "44900866818256", "nextCommerceId": "250", "IntervalCount": "4", "FrequencyTitle": "week"}, // 6 sacs  79
        {"shopifyId": "44900866392272", "nextCommerceId": "248", "IntervalCount": "4", "FrequencyTitle": "week"}, // 5    91
        {"shopifyId": "44900865179856", "nextCommerceId": "246", "IntervalCount": "4", "FrequencyTitle": "week"}, // 4       93

        {"shopifyId": "44598919266512", "nextCommerceId": "75", "IntervalCount": "4", "FrequencyTitle": "week"}, // 3 sacs
        {"shopifyId": "44598919299280", "nextCommerceId": "99", "IntervalCount": "4", "FrequencyTitle": "week"}, // 2 sacs
        {"shopifyId": "44598919332048", "nextCommerceId": "103", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598919397584", "nextCommerceId": "87", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598919561424", "nextCommerceId": "77", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598919594192", "nextCommerceId": "101", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598919626960", "nextCommerceId": "105", "IntervalCount": "4", "FrequencyTitle": "week"},
        {"shopifyId": "44598919659728", "nextCommerceId": "97", "IntervalCount": "4", "FrequencyTitle": "week"},

        {"shopifyId": "44900865147088", "nextCommerceId": "244", "IntervalCount": "12", "FrequencyTitle": "week"}, // 3 chats - 3 mois 244
        {"shopifyId": "44900864295120", "nextCommerceId": "242", "IntervalCount": "12", "FrequencyTitle": "week"}, // 3 chats - 1 mois 242
        {"shopifyId": "44900860625104", "nextCommerceId": "240", "IntervalCount": "12", "FrequencyTitle": "week"}, // 2 chats - 3 mois  240
        {"shopifyId": "44900860231888", "nextCommerceId": "238", "IntervalCount": "4", "FrequencyTitle": "week"}, // 2 chats - 1 mois 238
        {"shopifyId": "44900860199120", "nextCommerceId": "236", "IntervalCount": "12", "FrequencyTitle": "week"}, // 1 chat - 3 mois 236
        {"shopifyId": "44897829814480", "nextCommerceId": "205", "IntervalCount": "4", "FrequencyTitle": "week"} // 1 chats - 1 mois 205
    ];

  let selectedFrequency = $('input[name="selling_plan"]:checked').val();
  
  let checkOutChampId;
  let varId;
    //   if (selectedFrequency === '3_weeks') {
    //       checkOutChampId = $('#dropdown-product option:selected').attr('data-3-week-id');
    //       varId = $('#dropdown-product option:selected').attr('data-3-week-value');
    //   } else if (selectedFrequency === '4_weeks') {
    //      checkOutChampId = $('#dropdown-product option:selected').attr('data-4-week-id');
    //      varId = $('#linked-product-select option:selected').attr('data-4-week-value');
    //   }
  let variantId = $('#linked-product-select option:selected').val();
  
    let qty = 1;
    $.ajax({
      url: '/cart/clear.js',
      method: 'POST',
      dataType: 'json',
      success: function() {
          // After clearing, add the product
          $.ajax({
              url: '/cart/add.js',
              method: 'POST',
              data: { id: variantId, quantity: qty },
              dataType: 'json',
              success: function(data) {
                console.log('data added')
               $.getJSON('/cart.js', function(cart) {
                    
                    cart.items.forEach(function(item) {
                        // console.log("Cart Variant ID:", item.id, "Product ID:", item.product_id);

                        // Compare variant ID
                        var match = nextCommerceData.find(function(nc) {
                            return nc.shopifyId == item.id;
                        });
                         const lang = document.querySelector("html").getAttribute("lang") || "de";
                         const baseLang = lang.startsWith("fr") ? "fr" : "de";

                        if(match) {
                          console.log("Matched Variant ID:", item.id, "NextComment:", match.nextCommerceId);
                           let matchId = match.nextCommerceId;
                            // let IntervalCount = match.IntervalCount;
                            let IntervalCount = $('input[name="selling_plan"]:checked').attr('data-frequency');
                            let FrequencyTitle = match.FrequencyTitle;
                            let url = `https://pay.monpacha.ch/${baseLang}/checkout/add/?product=${matchId}:1`;

                            // only add IntervalCount if it exists
                            if (IntervalCount && IntervalCount !== "") {
                              url += `:${IntervalCount}`;
                              // only add FrequencyTitle if IntervalCount is there
                              if (FrequencyTitle && FrequencyTitle !== "") {
                                url += `:${FrequencyTitle}`;
                              }
                            }

                            window.location.href = url;

                          } else{
                            window.location = '/checkout';
                          }
                    });
                });

                  // window.location = `https://pay.mein-pacha.de/de/checkout?products=${checkOutChampId}:1`;
              },
              error: function(xhr, status, error) {
                  console.error("Error adding to cart:", error);
                  console.error("Response Text:", xhr.responseText);
                  window.alert(xhr.responseJSON.description);
              }
          });
      },
      error: function(xhr, status, error) {
          console.error("Error clearing cart:", error);
          console.error("Response Text:", xhr.responseText);
          window.alert("Failed to clear cart. Please try again.");
      }
  });
});

function goCheckout() {
    var val = $("#linked-product-select option:selected" ).text(); 
   
    if(val.indexOf("Katzen") != -1){
            checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');
    
        if (checkedRadio) {

            const quantityToSubmit = linkedProductsSelect ? 1 : quantity;

            const frequencyInputs = document.querySelectorAll('div[class="custom-recharge-form-radio"]');
            let frequency = "";

            frequencyInputs.forEach((input) => {
            radio = input.querySelector('input')
            label = input.querySelector('label')
            if (radio.checked)
                    frequency = label.textContent.replace('Livraison', 'livrés');
            });

            if(frequency.indexOf("3") != -1){
                var new_frequency = 3;
            } else {
                var new_frequency = 4;
            }
        
            let formData = {
                'items': [{
                    id: productId,
                    quantity: quantityToSubmit,
                    "properties": { "Lieferung": "alle "+new_frequency+" Wochen" }
                //  selling_plan: parseInt(checkedRadio.value)
                }]
            };

            console.log(formData);
            

            fetch(`/cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then(response => {
                window.location.href = '/checkout';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    } else {
    
        checkedRadio = radioContainer.querySelector('input[type="radio"]:checked');
    
        if (checkedRadio) {

            const quantityToSubmit = linkedProductsSelect ? 1 : quantity;
        
            let formData = {
                'items': [{
                    id: productId,
                    quantity: quantityToSubmit,
                    "properties": { "Livraison": checkedRadio.value }
                //  selling_plan: parseInt(checkedRadio.value)
                }]
            };

            console.log(formData);
            

            fetch(`/cart/add.js`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then(response => {
                window.location.href = '/checkout';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }
}

class ProductSelector extends HTMLElement{
    constructor(){
        super();

        this.select = this.querySelector('select');
    }

    connectedCallback(){
        this.setProductId();

        this.select.addEventListener('change', () => {
            this.setProductId();
            const activeOption = this.select.options[this.select.selectedIndex];
            this.setActiveFormRadios(activeOption.dataset.index);
        })

    }

    setProductId(){
        productId = parseInt(this.select.value);
    }

    setActiveFormRadios(index){
        const allRadios = document.querySelectorAll('.custom-recharge-form-radios')

        allRadios.forEach(radio => {
            if(radio.dataset.index === index){
                radio.classList.remove('hidden');

                const radioInputs =  radio.querySelectorAll('input');

                radioInputs[1].checked = true;
            }
            else{
                radio.classList.add('hidden');
            }
        })
    }
}

customElements.define('product-selector', ProductSelector);